'use strict';

import 'document-register-element';
import dispatcher from '../dispatcher';
import store from './slider.store';



class Control extends HTMLButtonElement {
  constructor(self) {
    self = super(self);
    self.init.call(self);
  }
  init(){
    this._hidden = false;

    this.subscribe = e => this._subscribe(e);
  }
  connectedCallback() {
    this._slider = this.dataset.slider;
    this._slide = +this.dataset.slide;
    this._active = this.classList.contains('active');

    this.addEventListener('click', this._click);

    this._subscribe(store.getData());
    store.eventEmitter.subscribe(this.subscribe);
  }
  disconnectedCallback() {
    store.eventEmitter.unsubscribe(this.subscribe);
  }

  _click() {
    dispatcher.dispatch({
      type: 'slider-navigate',
      _module: 'slider-control.component',
      slider: this._slider,
      slide: this._slide
    })
  }
  _subscribe(e) {
    if (!e.items.hasOwnProperty(this._slider)) return;

    if ((e.type === 'slider-emit' || e.type === undefined)) {
      let slider = e.items[this._slider];

      if (slider.activeStart === this._slide) {
        if (!this._active) {
          this.classList.add('active');
          this._active = true;
        }
      } else {
        if (this._active) {
          this.classList.remove('active');
          this._active = false;
        }
      }

      this._setHide(slider);
    } else if ('slider-enable-emit') {
      this._setHide(e.items[this._slider])
    }
  }

  _setHide(slider) {
    if (slider.disabled) {
      if (!this._hidden){
        this.classList.add('hidden');
        this._hidden = true;
      }
    } else {
      if (this._hidden){
        this.classList.remove('hidden');
        this._hidden = false;
      }
    }
  }
}


window.customElements.define('slider-control', Control, {extends: 'button'});
